module.exports = __webpack_public_path__ + "img/instagram.0ff3809e.png";